var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card', [_c('v-item-group', {
    attrs: {
      "multiple": ""
    },
    model: {
      value: _vm.selectedMedia,
      callback: function callback($$v) {
        _vm.selectedMedia = $$v;
      },
      expression: "selectedMedia"
    }
  }, [_c('v-container', {
    attrs: {
      "grid-list-sm": "",
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": ""
    }
  }, _vm._l(_vm.mediaItems, function (file) {
    return _c('v-flex', {
      key: file.id,
      attrs: {
        "xs4": ""
      }
    }, [file.collection_name == 'media' ? _c('v-item', {
      attrs: {
        "value": file
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function fn(_ref) {
          var active = _ref.active,
            toggle = _ref.toggle;
          return _c('v-card', {
            attrs: {
              "flat": "",
              "tile": "",
              "color": active ? 'primary' : ''
            }
          }, [_c('v-scroll-y-transition', [active ? _c('div', {
            staticClass: "text-xs-center pt-2 white--text"
          }, [_c('v-icon', {
            attrs: {
              "color": "white"
            }
          }, [_vm._v("check")]), _vm._v("\n                  " + _vm._s(_vm.$vuetify.t('$vuetify.preWorkAnalysis.selected')) + "\n                ")], 1) : _vm._e()]), _c('v-card-text', {
            class: active ? 'primary' : 'grey lighten-5'
          }, [_c('v-flex', {
            attrs: {
              "xs7": ""
            }
          }), _c('v-flex', {
            attrs: {
              "xs1": ""
            }
          }, [_c('v-icon', {
            attrs: {
              "color": "red",
              "absolute": "",
              "dark": "",
              "fab": "",
              "top": "",
              "right": ""
            },
            on: {
              "click": function click($event) {
                $event.stopPropagation();
                return _vm.deleteDialog(file);
              }
            }
          }, [_vm._v("delete")])], 1), file.type == 'image' ? _c('v-img', {
            staticClass: "grey lighten-2 media",
            attrs: {
              "src": file.url ? file.url : file.src,
              "aspect-ratio": "1"
            },
            on: {
              "click": toggle
            }
          }, [_c('v-layout', {
            attrs: {
              "slot": "placeholder",
              "fill-height": "",
              "align-center": "",
              "justify-center": "",
              "ma-0": ""
            },
            slot: "placeholder"
          }, [_c('v-progress-linear', {
            attrs: {
              "indeterminate": "",
              "color": "grey lighten-5"
            }
          })], 1)], 1) : _vm._e(), _c('v-tooltip', {
            attrs: {
              "bottom": ""
            }
          }, [_c('span', {
            staticClass: "description",
            attrs: {
              "slot": "activator"
            },
            on: {
              "click": function click($event) {
                return _vm.openDialog(file);
              }
            },
            slot: "activator"
          }, [_vm._v(_vm._s(file.description))]), _c('span', [_vm._v(_vm._s(file.description))])]), _c('v-icon', {
            attrs: {
              "color": "green",
              "absolute": "",
              "dark": "",
              "fab": "",
              "top": "",
              "right": ""
            },
            on: {
              "click": function click($event) {
                return _vm.openDialog(file);
              }
            }
          }, [_vm._v("edit")])], 1)], 1);
        }
      }], null, true)
    }) : _vm._e()], 1);
  }), 1)], 1)], 1), _c('v-dialog', {
    model: {
      value: _vm.dialog,
      callback: function callback($$v) {
        _vm.dialog = $$v;
      },
      expression: "dialog"
    }
  }, [_c('v-card', [_c('v-card-text', [this.dialogFile.type == 'image' ? _c('v-img', {
    staticStyle: {
      "max-height": "50vh"
    },
    attrs: {
      "src": this.dialogFile.url ? this.dialogFile.url : this.dialogFile.src,
      "contain": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "slot": "placeholder",
      "fill-height": "",
      "align-center": "",
      "justify-center": "",
      "ma-0": ""
    },
    slot: "placeholder"
  }, [_c('v-progress-linear', {
    attrs: {
      "indeterminate": "",
      "color": "grey lighten-5"
    }
  })], 1)], 1) : _c('video', {
    attrs: {
      "height": "100%",
      "width": "100%",
      "src": this.dialogFile.url ? this.dialogFile.url : this.dialogFile.src,
      "autoplay": "",
      "controls": ""
    }
  }), _c('v-textarea', {
    attrs: {
      "solo": "",
      "name": "description",
      "label": "Description"
    },
    model: {
      value: _vm.description,
      callback: function callback($$v) {
        _vm.description = $$v;
      },
      expression: "description"
    }
  })], 1), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "red",
      "fab": "",
      "bottom": "",
      "left": "",
      "dark": ""
    },
    on: {
      "click": _vm.closeDialog
    }
  }, [_c('v-icon', [_vm._v("close")])], 1), _c('v-spacer'), _c('v-btn', {
    attrs: {
      "color": "green",
      "fab": "",
      "bottom": "",
      "right": "",
      "dark": ""
    },
    nativeOn: {
      "click": function click($event) {
        return _vm.saveMedia();
      }
    }
  }, [_c('v-icon', [_vm._v("save")])], 1)], 1)], 1)], 1), _c('delete-dialog', {
    ref: "deleteDialog",
    attrs: {
      "preset": "delete"
    },
    on: {
      "deleted": _vm.deleteMediaConfirmed
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }